import { OBJECT } from '@pkg/config/sanity/schemas';
import { baseTextBlockConfig } from '@pkg/modular-blocks/blocks/inner/BaseText';
import { buttonGroupBlockConfig } from '@pkg/modular-blocks/blocks/inner/ButtonGroup';
import { faqBlockConfig } from '@pkg/modular-blocks/blocks/inner/FAQ';
import { formsBlockConfig } from '@pkg/modular-blocks/blocks/inner/Forms';
import { salesforceFormBlockConfig } from '@pkg/modular-blocks/blocks/inner/SalesforceForm';
import { statisticsBlockConfig } from '@pkg/modular-blocks/blocks/inner/Statistics';
import { tilesBlockConfig } from '@pkg/modular-blocks/blocks/inner/Tiles';
import { titleBlockConfig } from '@pkg/modular-blocks/blocks/inner/Title';
import { imageBlockConfig } from '@pkg/modular-blocks/blocks/inner/Image';
import { videoBlockConfig } from '@pkg/modular-blocks/blocks/inner/Video';
import { calloutBlockConfig } from '@pkg/modular-blocks/blocks/inner/Callout';
import { partnerLogoBlockConfig } from '@pkg/modular-blocks/blocks/inner/PartnerLogo';
import { tickerBlockConfig } from '@pkg/modular-blocks/blocks/inner/Ticker';
import { bagBlockConfig } from '@pkg/modular-blocks/blocks/outer/BagSection';
import { carouselSectionBlockConfig } from '@pkg/modular-blocks/blocks/outer/CarouselSection';
import { ctaSectionBlockConfig } from '@pkg/modular-blocks/blocks/outer/CTASection';
import { tickerSectionBlockConfig } from '@pkg/modular-blocks/blocks/outer/TickerSection';
import { solutionTilesBlockConfig } from '@pkg/modular-blocks/blocks/inner/SolutionTiles';
import { mainHeroBlockConfig } from '@pkg/modular-blocks/blocks/outer/MainHero';
import { referralBlockConfig } from '@pkg/modular-blocks/blocks/outer/Referral';
import { sectionBlockConfig } from '@pkg/modular-blocks/blocks/outer/Section';
import { solutionFinderBlockConfig } from '@pkg/modular-blocks/blocks/outer/SolutionFinder';
import { stepsSectionBlockConfig } from '@pkg/modular-blocks/blocks/outer/StepsSection';
import { subHeroBlockConfig } from '@pkg/modular-blocks/blocks/outer/SubHeroSection';
import ModularBlocksRenderer from '@pkg/modular-blocks/frontend/ModularBlocksRenderer.vue';
import type { ModularBlocksConfig } from '@pkg/modular-blocks/frontend/types';

export const modularBlocksConfig: ModularBlocksConfig = {
  modularRenderer: ModularBlocksRenderer,
  outer: {
    [OBJECT.MODULAR_OUTER_BLOCK_SECTION]: sectionBlockConfig,
    [OBJECT.MODULAR_OUTER_BLOCK_HERO]: mainHeroBlockConfig,
    [OBJECT.MODULAR_OUTER_BLOCK_CTA]: ctaSectionBlockConfig,
    [OBJECT.MODULAR_OUTER_BLOCK_CAROUSEL_SECTION]: carouselSectionBlockConfig,
    [OBJECT.MODULAR_OUTER_BLOCK_TICKER_SECTION]: tickerSectionBlockConfig,
    [OBJECT.MODULAR_OUTER_BLOCK_BAG]: bagBlockConfig,
    [OBJECT.MODULAR_OUTER_BLOCK_SUB_HERO]: subHeroBlockConfig,
    [OBJECT.MODULAR_OUTER_BLOCK_STEPS_SECTION]: stepsSectionBlockConfig,
    [OBJECT.MODULAR_OUTER_SOLUTION_FINDER]: solutionFinderBlockConfig,
    [OBJECT.MODULAR_OUTER_BLOCK_REFERRAL]: referralBlockConfig,
  },
  inner: {
    [OBJECT.MODULAR_INNER_BLOCK_TITLE]: titleBlockConfig,
    [OBJECT.MODULAR_INNER_BLOCK_BASE_TEXT]: baseTextBlockConfig,
    [OBJECT.MODULAR_INNER_BLOCK_TILES]: tilesBlockConfig,
    [OBJECT.MODULAR_INNER_BLOCK_SOLUTION_TILES]: solutionTilesBlockConfig,
    [OBJECT.MODULAR_INNER_BLOCK_BASE_BUTTON_GROUP]: buttonGroupBlockConfig,
    [OBJECT.MODULAR_INNER_BLOCK_FAQ]: faqBlockConfig,
    [OBJECT.MODULAR_INNER_BLOCK_FORMS]: formsBlockConfig,
    [OBJECT.MODULAR_INNER_BLOCK_SALESFORCE_FORMS]: salesforceFormBlockConfig,
    [OBJECT.MODULAR_INNER_BLOCK_STATISTICS]: statisticsBlockConfig,
    [OBJECT.MODULAR_INNER_BLOCK_CALLOUT]: calloutBlockConfig,
    [OBJECT.MODULAR_INNER_BLOCK_PARTNER_LOGO]: partnerLogoBlockConfig,
    [OBJECT.MODULAR_INNER_BLOCK_VIDEO]: videoBlockConfig,
    [OBJECT.MODULAR_INNER_BLOCK_IMAGE]: imageBlockConfig,
    [OBJECT.MODULAR_INNER_BLOCK_TICKER]: tickerBlockConfig,
  },
};
